import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enScreens from './locales/en/screens.json';
import enValidation from './locales/en/validation.json';
import nlCommon from './locales/nl/common.json';
import nlAuth from './locales/nl/auth.json';
import nlScreens from './locales/nl/screens.json';
import nlValidation from './locales/nl/validation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        screens: enScreens,
        validation: enValidation,
      },
      nl: {
        common: nlCommon,
        auth: nlAuth,
        screens: nlScreens,
        validation: nlValidation,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'conductor_language',
    },
  });

export default i18n;
